import { isAxiosError } from 'axios';

/** Expected 401 when a guest has no refresh cookie or session expired on /me. */
export function isGuestSessionProbeError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;
  if (error.response?.status !== 401) return false;
  const url = error.config?.url ?? '';
  return url.includes('/auth/refresh') || url.includes('/auth/me');
}

export function isAuthRefreshRequestUrl(url: string): boolean {
  return url.includes('/auth/refresh') || url.includes('/auth/me');
}
